export const environment = {
    production: false,
    hmr: false,
    appConfig: 'appconfig.devazure.json',
    uiVersion: require('../../package.json').version + '-dev',
    appInsights: {
        instrumentationKey: '95a6aa2d-6b6b-45d1-ab26-efe05d65bc71'
    }
};